import Form from './Form';
import List from './List';
import Cart from './Cart';

const Components = {
    Form : Form,
    List : List,
    Cart : Cart
}

export default Components;